import React from 'react';

const FlecheRevenirSvg = ({width = 20, height = 20, couleur = "#002335"}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 44 41"
         fill="none">
        <path
            d="M3.60648 31.3612C2.77806 31.3612 2.10648 32.0328 2.10648 32.8612C2.10648 33.6896 2.77806 34.3612 3.60648 34.3612V31.3612ZM9.0991 13.0702C8.51332 13.656 8.51332 14.6057 9.0991 15.1915L18.645 24.7375C19.2308 25.3232 20.1806 25.3232 20.7664 24.7375C21.3521 24.1517 21.3521 23.2019 20.7664 22.6161L12.2811 14.1309L20.7664 5.64558C21.3521 5.05979 21.3521 4.11004 20.7664 3.52426C20.1806 2.93847 19.2308 2.93847 18.645 3.52426L9.0991 13.0702ZM3.60648 34.3612H30.0464V31.3612H3.60648V34.3612ZM30.0464 34.3612C36.1788 34.3612 41.2397 29.5446 41.2397 23.496H38.2397C38.2397 27.7913 34.6202 31.3612 30.0464 31.3612V34.3612ZM41.2397 23.496C41.2397 17.4474 36.1788 12.6309 30.0464 12.6309V15.6309C34.6202 15.6309 38.2397 19.2008 38.2397 23.496H41.2397ZM30.0464 12.6309H10.1598V15.6309H30.0464V12.6309Z"
            fill={couleur}/>
    </svg>
);

export default FlecheRevenirSvg;
